var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVmlyr = function SvgVmlyr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2560 1440",
    height: 1440,
    width: 2560,
    xmlSpace: "preserve",
    id: "svg2"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath18",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path16",
    d: "M 0,1080 H 1920 V 0 H 0 Z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333333,0,0,-1.3333333,0,1440)",
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath18)",
    id: "g14"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1211.9796,624.8198)",
    id: "g20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path22",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillrule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 h 26.528 c 9.096,0 15.766,6.064 15.766,13.947 0,8.489 -5.761,13.34 -16.22,13.34 H 0 Z M 69.125,-59.423 H 41.99 L 21.374,-19.555 H 0 V -59.423 H -23.648 V 46.69 H 27.59 c 22.738,0 38.504,-11.824 38.504,-32.743 0,-15.159 -10.156,-25.013 -21.072,-29.258 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(710.129,565.3955)",
    id: "g24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path26",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillrule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 -34.129,106.604 H -8.544 L 12.792,30.916 34.128,106.604 H 59.713 L 25.585,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(828.5216,565.3955)",
    id: "g28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path30",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillrule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 -19.505,71.121 -39.272,0 h -25.434 l 30.859,106.604 H -9.023 L 10.965,35.789 30.954,106.604 H 55.777 L 86.636,0 H 61.203 L 41.436,71.121 21.931,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(929.3234,565.397)",
    id: "g32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path34",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillrule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 V 106.114 H 23.648 V 19.404 H 74.583 V 0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1020.8878,565.3955)",
    id: "g36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path38",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillrule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 v 43.052 l -40.778,63.062 h 28.045 L 11.824,65.336 36.686,106.114 H 64.578 L 23.648,43.052 V 0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1133.0333,585.2573)",
    id: "g40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path42",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillrule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 -22.739,27.135 c -4.699,-4.699 -7.731,-10.308 -7.731,-16.676 0,-8.488 6.67,-14.097 16.22,-14.097 5.003,0 9.854,1.213 14.25,3.638 M 43.961,-19.858 H 16.372 l -4.7,5.76 c -8.488,-5.003 -18.342,-7.731 -28.499,-7.731 -23.648,0 -37.443,11.975 -37.443,29.409 0,15.159 11.825,26.225 20.768,32.44 -5.912,7.428 -10.308,13.946 -10.308,22.132 0,15.766 13.34,26.225 30.015,26.225 13.644,0 24.255,-3.941 34.563,-16.371 L 5.608,59.121 c -5.912,8.034 -11.369,11.066 -16.826,11.066 -5.305,0 -8.793,-3.032 -8.793,-8.035 0,-6.063 6.823,-13.339 9.551,-16.674 L 15.159,14.704 c 3.79,6.215 6.064,13.34 6.518,20.92 H 41.232 C 40.777,21.829 35.775,9.399 27.741,-0.455 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1342.8263,467.6831)",
    id: "g44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path46",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillrule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 h 26.528 c 9.096,0 15.766,6.063 15.766,13.946 0,8.49 -5.761,13.341 -16.221,13.341 H 0 Z M 69.125,-59.424 H 41.99 L 21.374,-19.555 H 0 V -59.424 H -23.648 V 46.69 H 27.59 c 22.738,0 38.504,-11.824 38.504,-32.744 0,-15.158 -10.157,-25.012 -21.072,-29.257 z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path48",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillrule: "nonzero",
      stroke: "none"
    },
    d: "m 1538.228,514.621 h 81.724 v -21.172 h -81.724 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path50",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillrule: "nonzero",
      stroke: "none"
    },
    d: "m 1538.228,450.733 h 81.724 v 21.172 h -81.724 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path52",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillrule: "nonzero",
      stroke: "none"
    },
    d: "m 1538.228,408.013 h 81.724 v 21.172 h -81.724 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path54",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillrule: "nonzero",
      stroke: "none"
    },
    d: "m 1215.93,514.621 h 81.723 v -21.172 h -81.723 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path56",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillrule: "nonzero",
      stroke: "none"
    },
    d: "m 1215.93,450.733 h 81.723 v 21.172 h -81.723 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path58",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillrule: "nonzero",
      stroke: "none"
    },
    d: "m 1215.93,408.013 h 81.723 v 21.172 h -81.723 z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(673.2433,461.4678)",
    id: "g60"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path62",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillrule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,28.044 18.949,55.028 55.179,55.028 28.347,0 42.597,-15.614 48.054,-29.561 L 82.769,17.584 C 78.069,28.802 68.216,35.624 54.876,35.624 35.472,35.624 23.8,19.707 23.8,0.455 c 0,-21.829 12.43,-36.23 30.47,-36.23 13.037,0 23.497,7.882 28.801,21.525 l 20.617,-5.912 C 97.321,-41.839 78.979,-55.331 54.118,-55.331 18.342,-55.331 0,-29.105 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1418.1398,461.4678)",
    id: "g64"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path66",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillrule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,28.044 18.948,55.028 55.179,55.028 28.347,0 42.597,-15.614 48.054,-29.561 L 82.769,17.584 c -4.7,11.218 -14.553,18.04 -27.893,18.04 -19.404,0 -31.077,-15.917 -31.077,-35.169 0,-21.829 12.43,-36.23 30.471,-36.23 13.037,0 23.496,7.882 28.801,21.525 l 20.617,-5.912 C 97.321,-41.839 78.979,-55.331 54.118,-55.331 18.342,-55.331 0,-29.105 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(873.4347,461.4678)",
    id: "g68"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path70",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillrule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,21.678 -12.431,35.473 -32.138,35.473 -20.313,0 -32.289,-14.705 -32.289,-35.473 0,-19.404 10.612,-35.775 32.289,-35.775 C -9.854,-35.775 0,-19.404 0,0 m -88.378,-0.151 c 0,33.501 23.042,55.179 56.24,55.179 C 1.971,55.028 23.8,32.289 23.8,0 c 0,-30.47 -18.949,-55.331 -56.089,-55.331 -35.32,0 -56.089,23.8 -56.089,55.18"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(964.464,408.0127)",
    id: "g72"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path74",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillrule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 -19.505,71.121 -39.272,0 h -25.434 l 30.858,106.604 H -9.023 L 10.965,35.789 30.954,106.604 H 55.777 L 86.636,0 H 61.203 L 41.435,71.121 21.93,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1115.8058,408.0127)",
    id: "g76"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path78",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillrule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 -19.505,71.121 -39.272,0 h -25.434 l 30.859,106.604 H -9.023 L 10.965,35.789 30.954,106.604 H 55.777 L 86.636,0 H 61.203 L 41.435,71.121 21.931,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(522.0001,694)",
    id: "g80"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path82",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillrule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 h -44 l -44,-44 -44,44 h -44 l 88,-88 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(346.0002,386)",
    id: "g84"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path86",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillrule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 H 44 L 88,44 132,0 h 44 L 88,88 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(566.0001,694)",
    id: "g88"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path90",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillrule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 -132,-132 -264,0 h -22 v -22 l 132,-132 -132,-132 v -22 h 22 l 132,132 132,-132 h 22 v 22 L -110,-154 22,-22 V 0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280.0002,628)",
    id: "g92"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path94",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillrule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 V -44 L 44,-88 0,-132 v -44 l 88,88 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(588.0001,452)",
    id: "g96"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path98",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillrule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 v 44 l -44,44 44,44 v 44 L -88,88 Z"
  }))))));
};
export default SvgVmlyr;